export class RequestData {
    ConceptosClinicosImagenologicos: any;
    IdEmpresaProveedor: number;
    Documentos: any;
    CitaEnLinea: any;
    EstaLicenciado: boolean;
    NombrePhr: string | null;
    TituloPhr: string | null;
    IdResponsableServicioDestino: number;
    NombreResponsableServicioDestino: string;
    EmailResponsableServicio: string | null;
    TipoNotificacion: number;
    TipoSolicitud: number;
    IdPersonaEmisora: number;
    NombrePersonaEmisora: string;
    EmailPersonaEmisora: string;
    IdEmpresaCorporativa: number;
    IdEmpresaOrigen: number;
    NombreEmpresaOrigen: string | null;
    IdEmpresaDestino: number;
    IdEmpresaResponsableServicio: number;
    IdAreaSistemaDestino: number;
    Localizacion: any;
    ComentarioEmisor: string | null;
    CodigoVerificacion: string;
    ContactoOrigenPaciente: any;
    FechaInicio: Date;
    IdContactoClinico: any;
    IdPacientePhr: number;
    IdPacientePortal: number;
    IdEmpresaPortal: number;
    CheckoutUrl: any;
    RegistrosClinicos: any;
    RelacionEmisorPaciente: number;
    PacienteSolicitante: PatientData;
    UsuarioSolicitante: any;
    PagoDetalle: any;
    WorkflowPosition: number;
    EsUsuarioNuevo: boolean;
    Id: number;
}

export class PatientData {
    IdPacienteRelacionado: any;
    IdEmpresaRelacionada: any;
    IdEmpresa: number;
    Sexo: string;
    Email: string | null;
    EmailVerificado: any;
    NumeroTelefonoParticular: string | null;
    NumeroCelularParticular: string;
    FechaNacimiento: string;
    Nombre: string;
    Apellido: string;
    Denominacion: string;
    UbicacionFoto: any;
    ComentarioContacto: any;
    IdPaisResidencia: number;
    Id: number;
    NumeroCedula: string;
    NombreTipoSangre: string;
}